import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { usePermissions } from '../contexts/PermissionContext';

interface TenantModuleGateProps {
  moduleKey: string;
  children: React.ReactNode;
}

const TenantModuleGate: React.FC<TenantModuleGateProps> = ({ moduleKey, children }) => {
  const { canModule, ready } = usePermissions();

  if (!ready) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!canModule(moduleKey)) {
    return <Navigate to="/acceso-denegado" replace />;
  }

  return <>{children}</>;
};

export default TenantModuleGate;
